import { useGenomeViewerStore } from "../../../store/store.ts";

export function handleFeaturePopover(e: PointerEvent) {
  const el = document.getElementById("genome-viewer-contextual-menu");
  const { showFeaturePopover } = useGenomeViewerStore.getState();
  if (!el) {
    return;
  }
  if (!isChildOf(e.target as HTMLElement, el as HTMLElement) && showFeaturePopover) {
    const contextualMenu = document.getElementById("genome-viewer-contextual-menu");
    if (contextualMenu) {
      useGenomeViewerStore.setState({ showFeaturePopover: false, contextualMenuData: undefined });
      Object.assign(contextualMenu.style, {
        display: "none",
      });
    }
  }
}

function isChildOf(node: HTMLElement | null, el: HTMLElement) {
  if (node == null || node === document.body) {
    return false;
  }

  if (node === el) {
    return true;
  } else {
    return isChildOf(node.parentElement, el);
  }
}
